import { useTranslation } from 'react-i18next';
import './style.css';
import { Icon } from '@iconify/react/dist/iconify.js';

const PatientProfileSummary = ({ admissionDetails }) => {
    const { t } = useTranslation();

    return (
        <div className="patient-profile-summary-section">
            <h2 className="patient-profile-summary-title">
                <Icon icon="mdi:account-outline" width="25" height="25" />
                {t('patient-profile-summary')}
            </h2>

            {/* Medical Diagnosis / Primary Complaint */}
            <div className="patient-profile-summary-section-card">
                <h3 className="patient-profile-summary-section-title">{t('medical-diagnosis-primary-complaint')}</h3>
                <p className="patient-profile-summary-text">
                    {admissionDetails?.requestData?.medicalDiagnosis}
                </p>
            </div>

            {/* Height, Weight, Allergies */}
            <div className="patient-profile-summary-info-grid">
                <div className="patient-profile-summary-info-item">
                    <div className="patient-profile-summary-info-label">{t('height')}</div>
                    <div className="patient-profile-summary-info-value">{admissionDetails?.patientData?.height }</div>
                </div>
                <div className="patient-profile-summary-info-item">
                    <div className="patient-profile-summary-info-label">{t('weight')}</div>
                    <div className="patient-profile-summary-info-value">{admissionDetails?.patientData?.weight }</div>
                </div>
                <div className="patient-profile-summary-info-item">
                    <div className="patient-profile-summary-info-label patient-profile-summary-allergies-label">{t('allergies')}</div>
                    <div className="patient-profile-summary-info-value patient-profile-summary-allergies-value">
                        {admissionDetails?.patientData?.allergy}
                    </div>
                </div>
            </div>

            {/* Medical Family History */}
            <div className="patient-profile-summary-section-card">
                <h3 className="patient-profile-summary-section-title">{t('medical-family-history')}</h3>
                <p className="patient-profile-summary-text">
                    {admissionDetails?.patientData?.familyMedicalHistory}
                </p>
            </div>
        </div>
    );
};

export default PatientProfileSummary;

